"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormEvent = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var FormContext_1 = tslib_1.__importDefault(require("./FormContext"));
;
/** @deprecated @pinto/react-form is not needed anymore, just use MobX */
var FormEvent = /** @class */ (function (_super) {
    tslib_1.__extends(FormEvent, _super);
    function FormEvent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            result: null,
        };
        _this._isUnmounted = false;
        return _this;
    }
    FormEvent.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, render = _a.render, on = _a.on, callback = _a.callback;
        if (!this.context.registerField) {
            throw new Error("<FormEvent on='" + on + "' /> used outside of a <Form />");
        }
        if (render && callback) {
            console.warn("<FormEvent on='" + on + "' /> callback and render are not supported at once. Using only callback()");
        }
        if (callback) {
            this._unregister = this.context.registerEvent(this, on, callback);
        }
        else if (render) {
            this.setStateSafe({
                result: render(this.context.getFormProps()),
            });
            this._unregister = this.context.registerEvent(this, on, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.setStateSafe({ result: render.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args))) });
            });
        }
    };
    FormEvent.prototype.componentWillUnmount = function () {
        this._isUnmounted = true;
        if (this._unregister)
            this._unregister();
    };
    FormEvent.prototype.setStateSafe = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this._isUnmounted)
            return;
        return this.setState.apply(this, tslib_1.__spreadArray([], tslib_1.__read(args)));
    };
    FormEvent.prototype.render = function () {
        return this.state.result;
    };
    FormEvent.contextType = FormContext_1.default;
    FormEvent.propTypes = {
        on: prop_types_1.default.string.isRequired,
        callback: prop_types_1.default.func,
        render: prop_types_1.default.func,
    };
    return FormEvent;
}(react_1.default.PureComponent));
exports.FormEvent = FormEvent;
exports.default = FormEvent;
//# sourceMappingURL=FormEvent.js.map